<ng-content></ng-content>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/list/item/list.item.component.html